const urls = {
  // 用户管理,
  comuser: {
    list: "/admin/user/page",
    searlist: "/admin/user/searchList",
    adduser: "/admin/user/save",
    deluser: "/admin/user/delete",
    getInfo:'/admin/user/info'
  },
  // 文章管理
  article: {
    list: "/admin/article/articleTypeList",
    homelocation: "/admin/article/indexTypeList",
    savearticle: "/admin/article/save",
    upload:'/admin/attachFile/saveList',
    attachFileList:'/admin/attachFile/list',
    deleteFile:'/admin/attachFile/delete'
  },
  // banner
  banneradmin: {
    list: "/admin/banner/page",
    bannerfllist: "/admin/banner/bannerTypeList",
    savebanner: "/admin/banner/save",
    delbanner: "/admin/banner/delete"
  },
  // friendsLink
  friendLink: {
    list: "/admin/link/page",
    save: "/admin/link/save",
    del: "/admin/link/delete"
  },
  contact: {
    list: "/admin/contract/page",
    savelist: "/admin/contract/save",
    dellist: "/admin/contract/delete"
  },
  media: {
    list: "/admin/media/page",
    list2: "/admin/media/list",
    update: "/admin/media/update",
    add: "/admin/media/add",
    delete: "/admin/media/delete"
  },
  mediaGroup: {
    list: "/admin/mediaGroup/page",
    list2: "/admin/mediaGroup/list",
    update: "/admin/mediaGroup/update",
    add: "/admin/mediaGroup/add",
    delete: "/admin/mediaGroup/delete"
  },
  mediaGroupRelation: {
    list: "/admin/mediaGroupRelation/list",
    add: "/admin/mediaGroupRelation/add",
    delete: "/admin/mediaGroupRelation/delete"
  },

  communityGroup: {
    list: "/admin/group/page",
    list2: "/admin/group/list",
    update: "/admin/group/update",
    add: "/admin/group/add",
    delete: "/admin/group/delete",
    getarea: "/admin/area/list"
  },

  textType:{
    typeList:'/admin/article/articleTypeList',
  },
  

  login: "/admin/user/login"
};

export default {
  install: function(Vue, Option) {
    Object.defineProperty(Vue.prototype, "$urls", { value: urls });
  }
};



// WEBPACK FOOTER //
// ./src/api/urls.js